import "@radix-ui/themes/styles.css";
import { RouterProvider } from "react-router-dom";
import { router } from "@/routes/Routes";
import { Theme } from "@radix-ui/themes";

function App() {
  return (
    <Theme appearance="light">
      <RouterProvider router={router} />
    </Theme>
  );
}

export default App;
